import { 
    getDataWithParams,
    postData,
    getAllData,
    destroyData
} from '@/store/api/method-mbkm'

const itemInit = {
    id: null,
    pic: null,
    address: null,
    phone_number: null,
    email: null,
    quota: null,
    description: null,
    start_date: null,
    end_date: null,
    name: null,
    type: null,
    date: []
}

const requestInit = {
    page: 1,
    show: 10,
    sortBy: 'created_at',
    sorting: "DESC",
    search: null,
    filter: null
}

const initialState = () => ({
    data: {},
    msg: "Jaringan Bermasalah",
    status: 0,
    item: {...itemInit},
    request: {...requestInit},
    institusiStatus: [
        {
            status: 0,
            label: "Tidak Aktif",
            type: "danger"
        },
        {
            status: 1,
            label: "Aktif",
            type: "success"
        }
    ],
    institutions: []
})

const state = initialState

const getters = {
    getData: state => state.data || {},
    getItem: state => state.item,
    getStatus: state => state.status,
    getMsg: state => state.msg,
    getRequest: state => state.request,
    getInstitusiStatus: state => (status) => state.institusiStatus.find(x => x.status == status),
    getInstitutions: state => state.institutions || [],
}

const mutations = {
    SET_FAILED(state) {
        state.msg = 'Jaringan Bermasalah'
        state.status = 0
    },
    SET_MSG_FAILED(state, err) {
        if (err.status == 400) {
            state.msg = err.data.msg
            state.status = err.data.status
        } else {
            state.msg = 'Jaringan Bermasalah'
            state.status = 0
        }
    },
    SET_RESPONSE(state, response) {
        state.msg = response.msg
        state.status = response.status
    },
    SET_DATA(state, value) {
        state.data = value
    },
    SET_ITEM(state, value) {
        state.item = value
    },
    SET_REQUEST(state, value) {
        state.request = value
    },
    SET_INSTITUTIONS(state, value) {
        state.institutions = value
    },
    resetState(state) {
        const initial = initialState()
        Object.keys(initial).forEach(key => { state[key] = initial[key] })
    }
}

const actions = {
    resetRequest({commit }) {
        commit('SET_REQUEST', {...requestInit})
    },
    setItem({commit }, value) {
        commit('SET_ITEM',{...value})
    },
    resetItem({commit }) {
        commit('SET_ITEM', {...itemInit})
    },
    async getDataSekolah({commit, state }) {
        try {
            const response = await getDataWithParams('/sekolah', state.request)
            commit('SET_RESPONSE', response.data)
            commit('SET_DATA', response.data.data)
        } catch (err) {
            if (err.response) {
                commit('SET_MSG_FAILED', err.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },
    async getDataDesa({commit, state }) {
        try {
            const response = await getDataWithParams('/desa', state.request)
            commit('SET_RESPONSE', response.data)
            commit('SET_DATA', response.data.data)
        } catch (err) {
            if (err.response) {
                commit('SET_MSG_FAILED', err.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },
    async getAllSekolah({commit }) {
        try {
            const response = await getAllData('/sekolah-all')
            commit('SET_RESPONSE', response.data)
            commit('SET_INSTITUTIONS', response.data.data)
        } catch (err) {
            if (err.response) {
                commit('SET_MSG_FAILED', err.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },
    async getAllDesa({commit }) {
        try {
            const response = await getAllData('/desa-all')
            commit('SET_RESPONSE', response.data)
            commit('SET_INSTITUTIONS', response.data.data)
        } catch (err) {
            if (err.response) {
                commit('SET_MSG_FAILED', err.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },
    async store({commit }, data) {
        try {
            const payload = {...data}
            delete payload.id
            const response = await postData('/institution', payload)
            commit('SET_RESPONSE', response.data)
        } catch (err) {
            if (err.response) {
                commit('SET_MSG_FAILED', err.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },
    async update({commit }, data) {
        try {
            const url = `/institution/${data.id}`
            const payload = {...data}
            delete payload.id
            const response = await postData(url, payload)
            commit('SET_RESPONSE', response.data)
        } catch (err) {
            if (err.response) {
                commit('SET_MSG_FAILED', err.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },
    async updateStatus({commit }, data) {
        try {
            const url = `institution/status/${data.id}`
            const payload = {...data}
            delete payload.id
            const response = await postData(url, data)
            commit('SET_RESPONSE', response.data)
        } catch (err) {
            if (err.response) {
                commit('SET_MSG_FAILED', err.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },
    async delete({commit }, data) {
        try {
            const url = `/institution/${data.id}`
            const response = await destroyData(url)
            commit('SET_RESPONSE', response.data)
        } catch (err) {
            if (err.response) {
                commit('SET_MSG_FAILED', err.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },
    resetState({commit}) {
        commit('resetState')
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}